export default "__VITE_ASSET__7d3f742b__"